/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { userActions, selectUser } from "Features/user";

import { Button, DropdownCustom, LoaderRing } from "Shared/ui";
import tenPinCamLogo from "Shared/images/Logo-TenPinCam.png";

import "./main_header.scss";
import { Avatar } from "Entities/avatar";
import { authActions, selectAuth } from "Features/auth";
import { balanceActions } from "Features/balance";
import { selectBalance } from "Features/balance/balance.select";

export const MainHeader = () => {
	const user = useSelector(selectUser.data);
	const authFetch = useSelector(selectAuth.fetch);
	const balance = useSelector(selectBalance.data)?.balance;
	const balanceFetch = useSelector(selectBalance.fetch);
	const dispatch = useDispatch();
	function logout() {
		dispatch(authActions.logout());
	}

	useEffect(() => {
		dispatch(balanceActions.get());
		return () => dispatch(balanceActions.drop());
	}, []);

	return (
		<div className="main-header">
			<div className="main-header__container">
				<div className="main-header__first-row">
					{/* <DropdownCustom placeholder={user?.language} /> */}
					<Button text="Log out" onClick={logout} isLoading={authFetch} />
				</div>
				<div className="main-header__second-row">
					<div style={{ display: "flex", alignItems: "center" }}>
						<div className="main-header__logo">
							<img src={tenPinCamLogo} alt={"logo"} />
						</div>
						<div className="main-header__balance">
							<span className="main-header__balance_bold">BALANCE</span>
							<span className="main-header__balance_medium">€ {balance}</span>
						</div>
					</div>
					<div className="main-header__user mr-40">
						<Avatar user={user} className="mr-14" />
						<div className="main-header__user-data">
							<div className="main-header__user-firstname">{`${user?.first_name} ${user?.last_name}`}</div>
							<div className="main-header__user-lastname">{user?.login}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
